import React, {Component} from 'react';
import Doc from '../diyComponents/Documentation';
import DocTwo from '../diyComponents/DocumentationTwo';
import DocThree from '../diyComponents/DocumentationThree';
import DocFive from '../diyComponents/DocumentationFour';
import DocFour from '../diyComponents/DocumentationFive';
import "../assets/wizCSS/smart_wizard.css";
import "../assets/wizJS/jquery.smartWizard.js";
import "../assets/wizCSS/smart_wizard_theme_arrows.css";
import msparcs from "assets/img/doc1.PNG";
import $ from 'jquery';


class Home extends Component {

    componentDidMount() {

        // Step show event
        $("#smartwizard").on("showStep", function (e, anchorObject, stepNumber, stepDirection, stepPosition) {
            //alert("You are on step "+stepNumber+" now");
            if (stepPosition === 'first') {
                $("#prev-btn").addClass('disabled');
            } else if (stepPosition === 'final') {
                $("#next-btn").addClass('disabled');
            } else {
                $("#prev-btn").removeClass('disabled');
                $("#next-btn").removeClass('disabled');
            }
        });

        $("#smartwizard").on("endReset", function () {
            $("#next-btn").removeClass('disabled');
        });

        // Toolbar extra buttons
        var btnFinish = $('<button></button>').text('Finish')
            .addClass('btn btn-info diyWiZBtnHid')
            .on('click', function () {
                alert('Finish Clicked');
            });
        var btnCancel = $('<button></button>').text('Cancel')
            .addClass('btn btn-danger diyWiZBtnHid')
            .on('click', function () {
                $('#smartwizard').smartWizard("reset");
            });


        // Smart Wizard
        $('#smartwizard').smartWizard({
            selected: 0,
            theme: 'arrows',
            transitionEffect: 'fade',
            showStepURLhash: true,
            toolbarSettings: {
                toolbarPosition: 'none',
                toolbarButtonPosition: 'end',
                toolbarExtraButtons: [btnFinish, btnCancel]
            },
            anchorSettings: {
                anchorClickable: true, // Enable/Disable anchor navigation
                enableAllAnchors: true, // Activates all anchors clickable all times
                markDoneStep: true, // add done css
                enableAnchorOnDoneStep: true // Enable/Disable the done steps navigation
            },
        });


        // External Button Events
        $("#reset-btn").on("click", function () {
            // Reset wizard
            $('#smartwizard').smartWizard("reset");
            $("#next-btn").removeClass('disabled');
            return true;
        });

        $("#prev-btn").on("click", function () {
            // Navigate previous
            $('#smartwizard').smartWizard("prev");
            return true;
        });

        $("#next-btn").on("click", function () {
            // Navigate next
            $('#smartwizard').smartWizard("next");
            return true;
        });


        $('html, body').animate({scrollTop: 0}, 'fast');

        // for(let i=0; i<5; i++){
        //     document.getElementById("next-btn").click();
        // }
        //
        // for(let i=0; i<5; i++){
        //     document.getElementById("prev-btn").click();
        // }

    }

    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div>
                                    <div className="header">
                                        <h4 className="title">Getting Started </h4>
                                    </div>
                                    <hr/>
                                    <div className="p-10 p-t-0">
                                        <p>
                                            This portal will help to integrate billing POS with Innoviti integration
                                            server, developers
                                            should be able to test/simulate end-to-end payment flow.</p>
                                        <p>The quick start guide below will take you through all the necessary steps to
                                            test and
                                            integrate billing server through the API. Using this portal client’s
                                            integration development
                                            team should access to below options:</p>
                                    </div>

                                    <div className="p-10 p-t-0 ">
                                        <h6>◦ API documentation</h6>
                                        <blockquote>
                                            <small>Sample client code (Integration) in all popular languages </small>

                                            <small> Get API collection and environment</small>
                                        </blockquote>
                                        <h6>◦ API logs for debugging purpose</h6>
                                        <br/>
                                        <h6>◦ Simulate payment terminal (EDC) </h6>
                                    </div>

                                    <div className="typo-line">
                                        <p>Flow of actions between entities involved namely – Billing POS, Integration
                                            Server &
                                            Terminal</p>
                                        <div className="clearfix"></div>

                                        <img src={msparcs} alt={msparcs} className="mSpaceLogo" width={'80%'}/>
                                        <br/>
                                        <div className="clearfix"></div>

                                        <blockquote>
                                            <small>Cloud Integration Testing Developer can generate invoice on provided
                                                environment.</small>
                                            <small>Simulate payment terminal (EDC) Generated invoice payment can be done
                                                on EDC
                                                simulator. </small>
                                        </blockquote>
                                        <p>
                                            This way developer can test end to end payment flow.
                                        </p>

                                    </div>
                                </div>

                                <div id="smartwizard">
                                    <ul>
                                        <li><a href="#step-1">API <br/><small>Documentation</small></a></li>
                                        <li><a href="#step-2">Get<br/><small>Collection</small></a></li>
                                        <li><a href="#step-3">Get<br/><small>Environment</small></a></li>
                                        {/*<li><a href="#step-4">Web<br/><small>Loggger</small></a></li>*/}
                                        <li><a href="#step-5">Terminal<br/><small>Simulator</small></a></li>
                                    </ul>

                                    <div>
                                        <div id="step-1" className="">
                                            <Doc/>
                                        </div>
                                        <div id="step-2" className="">
                                            <DocTwo/>
                                        </div>
                                        <div id="step-3" className="">
                                            <DocThree/>
                                        </div>
                                        {/*<div id="step-4" className="">
                            <DocFour />
                        </div>*/}
                                        <div id="step-5" className="">
                                            <DocFive/>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="header">
                                        <h4 className="title">Feature Permission's</h4>
                                    </div>
                                    <hr/>
                                    <div className="p-l-20">
                                        <p>Each account provides different levels of access to portal features.</p>
                                    </div>
                                    <div class="content table-responsive">
                                        <table class="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="50%"><b>Features</b></th>
                                                <th width="25%"><center><b>Developer</b></center></th>
                                                <th width="25%"><center><b>Developer with Integration Key</b></center></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td><b>API Documentation</b></td>
                                                <td align="center"><b>X</b></td>
                                                <td align="center"><b>X</b></td>
                                            </tr>
                                            <tr>
                                                <td><b>API Collection</b></td>
                                                <td align="center"><b></b></td>
                                                <td align="center"><b>X</b></td>
                                            </tr>
                                            <tr>
                                                <td><b>Environment</b></td>
                                                <td align="center"><b></b></td>
                                                <td align="center"><b>X</b></td>
                                            </tr>
                                           {/* <tr>
                                                <td><b>Web Logger</b></td>
                                                <td align="center"><b></b></td>
                                                <td align="center"><b>X</b></td>
                                            </tr>*/}
                                            <tr>
                                                <td><b>Terminal Simulator</b></td>
                                                <td align="center"><b></b></td>
                                                <td align="center"><b>X</b></td>
                                            </tr>
                                            <tr>
                                                <td><b>Transaction Report</b></td>
                                                <td align="center"><b></b></td>
                                                <td align="center"><b>X</b></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="typo-line">
                                        <blockquote>
                                            <small>If you need to access a capability you don't currently have,
                                                please contact
                                                innoviti relation manger.</small>
                                        </blockquote>
                                    </div>
                                    <br/>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;